import Vue from 'vue'
import Router from 'vue-router'
import Profile from '../views/Profile.vue'
import Login from '../views/Login.vue'
import SignUp from '../views/SignUp.vue'
import Alternanza from '../views/Enterprise/Alternanza.vue'
import Appartenenza from "../views/Appartenenza.vue"
import GestionePeriodi from "../views/Institute/GestionePeriodi.vue";
// import DettaglioAssociazione from "../views/Enterprise/DettaglioAssociazione.vue";
import IscrizioniColloqui from "../views/Enterprise/IscrizioniColloqui.vue";
import Proposte from "../views/Enterprise/Proposte.vue";
import Apprendistati from '../views/Institute/Apprendistati.vue'
// import TirociniAzienda from "../views/Enterprise/TirociniAzienda.vue";
import WorkshopAzienda from "../views/Enterprise/WorkshopAzienda.vue";
import IncontriAzienda from "../views/Enterprise/IncontriAzienda.vue";
import ListaUtenti from "../views/AdminPage/ListaUtenti.vue";
import ListaAllievi from "../views/AdminPage/ListaAllievi.vue";
import ListaAziende from "../views/AdminPage/ListaAziende.vue";
// import AssegnazioneTutorArticolazione from "../views/AdminPage/AssegnazioneTutorArticolazione.vue";
import SignUpSuccess from "../views/SignUpSuccess.vue";
import ValidationPage from "../views/ValidationPage.vue";
import SessionExpired from "../views/SessionExpired.vue";
import ResetPasswordPage from "../views/ResetPasswordPage.vue";
import AuthorizationPage from "../views/Students/AuthorizationPage.vue";
import StudentsModules from "../views/Students/StudentsModules.vue";
import Modules from "../views/AdminPage/Modules.vue"
import GestioneAlternanza from "../views/Institute/GestioneAlternanza.vue";
import GestioneApprendistatoDuale from "../views/Institute/GestioneApprendistatoDuale.vue";
import GestioneTirocinioCurriculare from "../views/Institute/GestioneTirocinioCurriculare.vue";
import GestioneTirReInserimentoTutor from "../views/Institute/GestioneTirReInserimentoTutor.vue";
// import GestioneTirocinioFormativo from "../views/Institute/GestioneTirocinioFormativo.vue";
import CurriculumVitae from "../views/Students/CurriculumVitae.vue";
import OfferteLavoroStudente from "../views/Students/OfferteLavoroStudente.vue";
import NominaResponsabile from "../views/Enterprise/NominaResponsabile.vue";
import Review from "../views/AdminPage/Review.vue";
import IscrizioniAlternanza from "../views/Enterprise/IscrizioniAlternanza.vue";
import RichiestaTirocinanti from "../views/Enterprise/RichiestaTirocinanti.vue";
import Documents from "../views/Documents.vue";
import AssegnazioneTutorAllievi from "../views/Institute/AssegnazioneTutorAllievi.vue";
import AssegnazioneAllieviAziende from "../views/Institute/AssegnazioneAllieviAziende.vue"
import GestioneAlternanzaTutor from "../views/Institute/GestioneAlternanzaTutor.vue"
import GestioneAlternanzaAzienda from "../views/Enterprise/GestioneAlternanzaAzienda.vue"
import GestioneProgettoCV from "../views/Institute/GestioneProgettoCV.vue";
import ColloquiAzienda from "../views/Enterprise/ColloquiAzienda.vue"
import ElencoColloquiCV from "../views/Institute/ElencoColloquiCV.vue"
import IscrizioniTirEstivi from "../views/Enterprise/IscrizioniTirEstivi.vue"
// import TirociniEstiviAzienda from "../views/Enterprise/TirociniEstiviAzienda.vue"
import RichiestaTirocinantiEstivi from "../views/Enterprise/RichiestaTirocinantiEstivi.vue"
import TirEstivi from "../views/Enterprise/TirEstivi.vue"
import GestioneTirEstiviAzienda from "../views/Enterprise/GestioneTirEstiviAzienda.vue"
import GestioneTirEstiviTutor from "../views/Institute/GestioneTirEstiviTutor.vue"
import AssegnazioneAllieviAziendeTirEstivi from "../views/Institute/AssegnazioneAllieviAziendeTirEstivi.vue"
import GestioneTirEstivi from "../views/Institute/GestioneTirEstivi.vue"
import GestioneTirEstiviTutorForm from "../views/Institute/GestioneTirEstiviTutorForm.vue"
import TirFormativi from "../views/Enterprise/TirFormativi.vue"
import GestioneTirFormativiAzienda from "../views/Enterprise/GestioneTirFormativiAzienda.vue"
import IscrizioniTirFormativi from "../views/Enterprise/IscrizioniTirFormativi.vue"
import RichiestaTirocinantiFormativi from "../views/Enterprise/RichiestaTirocinantiFormativi.vue"
import AssegnazioneAllieviAziendeTirFormativi from "../views/Institute/AssegnazioneAllieviAziendeTirFormativi.vue"
import GestioneTirFormativi from "../views/Institute/GestioneTirFormativi.vue"
import GestioneTirFormativiTutor from "../views/Institute/GestioneTirFormativiTutor.vue"
import GestioneTirFormativiTutorForm from "../views/Institute/GestioneTirFormativiTutorForm.vue"
import GestioneTirEstiviTutorAzienda from "../views/Enterprise/GestioneTirEstiviTutorAzienda.vue"
import GestioneReportVisite from "../views/AdminPage/GestioneReportVisite.vue"
import Curriculum from "../views/AdminPage/Curriculum.vue"
import CurriculumAnno from "../views/AdminPage/CurriculumAnno.vue"
import CurriculumArticolazioni from "../views/AdminPage/CurriculumArticolazioni.vue"
import CurriculumClassi from "../views/AdminPage/CurriculumClassi.vue"
import CurriculumAllievi from "../views/AdminPage/CurriculumAllievi.vue"
import GestioneTirFormativiTutorAzienda from "../views/Enterprise/GestioneTirFormativiTutorAzienda.vue"
import ListaAttivita from "../views/AdminPage/ListaAttivita.vue"
import GestioneAlternanzaTutorAzienda from "../views/Enterprise/GestioneAlternanzaTutorAzienda.vue"
import GestioneAlternanzaTutorForm from "../views/Institute/GestioneAlternanzaTutorForm.vue"
import IscrizioniAttivitaAllievo from "../views/Students/IscrizioniAttivitaAllievo.vue"
import IscrizioniWokshop from "../views/Enterprise/IscrizioniWorkshop.vue"
import AssegnazioneAllieviAziendeTirReIns from "../views/Institute/AssegnazioneAllieviAziendeTirReIns.vue"
import GestioneTirReInsAzienda from "../views/Enterprise/GestioneTirReInsAzienda.vue"
import GestioneIscrizioniWorkshop from "../views/Institute/GestioneIscrizioniWorkshop.vue"
import QuestionariWorkshop from "../views/Institute/QuestionariWorkshop.vue"
import SchedulazioneWorkshop from "../views/Institute/SchedulazioneWorkshop.vue"
import SchedulazioneWorkshopTutor from "../views/Institute/SchedulazioneWorkshopTutor.vue"
import ElencoAllieviAssegnatiTutor from "../views/Institute/ElencoAllieviAssegnatiTutor.vue"
import ProposteLavoro from "../views/Institute/ProposteLavoro.vue";
import ListaAllieviIscrittiAlternanza from "../views/AdminPage/ListaAllieviIscrittiAlternanza.vue"
import ListaAllieviIscrittiTirEstivi from "../views/AdminPage/ListaAllieviIscrittiTirEstivi.vue"
import ListaAllieviIscrittiTirFormativo from "../views/AdminPage/ListaAllieviIscrittiTirFormativo.vue"
import ListaAllieviIscrittiTirReIns from "../views/AdminPage/ListaAllieviIscrittiTirReIns.vue"
import AssegnazioneAreeAllievi from "../views/AdminPage/AssegnazioneAreeAllievi.vue"
import AssegnazioneAreeAziende from "../views/AdminPage/AssegnazioneAreeAziende.vue"
import AllieviSettoreAlternanza from "../views/Institute/AllieviSettoreAlternanza.vue"
import Statistiche from '@/views/AdminPage/Statistiche.vue';

import PDFPreview from "../views/PDFPreview.vue"
import Crypt from "../views/Crypt.vue";


Vue.use(Router)

export const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/profilo',
      name: 'profilo',
      props: true,
      component: Profile
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: SignUp
    },
    {
      path: '/alternanzaAzienda',
      name: 'alternanzaAzienda',
      props: true,
      component: Alternanza
    },
    {
      path: '/appartiene/:tipoSoggetto',
      name: 'appartenenza',
      props: true,
      component: Appartenenza
    },
    {
      path: '/gestionePeriodi',
      name: 'gestionePeriodi',
      component: GestionePeriodi
    },
    // {
    //   path: '/dettaglioAssociazione/:tipoAssociazione/:idAssociazione',
    //   name: 'dettaglioAssociazione',
    //   props: true,
    //   component: DettaglioAssociazione
    // },
    {
      path: '/iscrizioniColloqui',
      name: 'iscrizioniColloqui',
      component: IscrizioniColloqui
    },
    {
      path: '/proposte',
      name: 'proposte',
      component: Proposte
    },
    // {
    //   path: '/tirociniAzienda',
    //   name: 'tirociniAzienda',
    //   component: TirociniAzienda
    // },
    {
      path: '/workshopAzienda',
      name: 'workshopAzienda',
      props: true,
      component: WorkshopAzienda
    },
    {
      path: '/incontriAzienda',
      name: 'incontriAzienda',
      component: IncontriAzienda
    },
    {
      path: '/elencoUtenti',
      name: 'elencoUtenti',
      component: ListaUtenti
    },
    {
      path: '/elencoAllievi',
      name: 'elencoAllievi',
      component: ListaAllievi
    },
    {
      path: '/elencoAziende',
      name: 'elencoAziende',
      component: ListaAziende
    },
    // {
    //   path: '/assegnazioneTutorArticolazione',
    //   name: 'tutorArticolazione',
    //   component: AssegnazioneTutorArticolazione
    // },
    {
      path: '/signUpSuccess',
      name: 'signUpSuccess',
      component: SignUpSuccess
    },
    {
      path: '/validationPage',
      name: 'validationPage',
      props: true,
      component: ValidationPage

    },
    {
      path: '/sessionExpired',
      name: 'sessionExpired',
      component: SessionExpired
    },
    {
      path: '/resetPasswordPage',
      name: 'resetPasswordPage',
      props: true,
      component: ResetPasswordPage
    },
    {
      path: '/authorizationPage',
      name: 'authorizationPage',
      props: true,
      component: AuthorizationPage
    },
    {
      path: '/moduliStudente',
      name: 'moduliStudente',
      component: StudentsModules
    },
    {
      path: '/moduli',
      name: 'moduli',
      component: Modules
    },
    {
      path: '/alternanzaIstituto',
      name: 'alternanzaIstituto',
      component: GestioneAlternanza
    },
    {
      path: '/apprendistatoIstituto',
      name: 'apprendistatoIstituto',
      component: GestioneApprendistatoDuale
    },
    {
      path: '/curriculareIstituto',
      name: 'curriculareIstituto',
      component: GestioneTirocinioCurriculare
    },
    {
      path: '/gestioneTirReInsTutor',
      name: 'gestioneTirReInsTutor',
      component: GestioneTirReInserimentoTutor
    },
    // {
    //   path: '/formativoIstituto',
    //   name: 'formativoIstituto',
    //   component: GestioneTirocinioFormativo
    // },
    {
      path: '/curriculumStudente',
      name: 'curriculumStudente',
      component: CurriculumVitae
    },
    {
      path: '/offerteLavoro',
      name: 'offerteLavoro',
      component: OfferteLavoroStudente
    },
    {
      path: '/nominaResponsabile',
      name: 'nominaResponsabile',
      component: NominaResponsabile,
      props: true
    },
    {
      path: '/review',
      name: 'review',
      props: true,
      component: Review
    },
    {
      path: '/pdfPreview',
      name: 'pdfPreview',
      component: PDFPreview
    },
    {
      path: '/iscrizioniAlternanza',
      name: 'iscrizioniAlternanza',
      component: IscrizioniAlternanza
    },
    {
      path: '/richiestaTirocinanti',
      name: 'richiestaTirocinanti',
      props: true,
      component: RichiestaTirocinanti
    },
    {
      path: '/documenti',
      name: 'documenti',
      component: Documents
    },
    {
      path: '/tutorAllievi',
      name: 'tutorAllievi',
      component: AssegnazioneTutorAllievi
    },
    {
      path: '/allieviAziende',
      name: 'allieviAziende',
      component: AssegnazioneAllieviAziende
    },
    {
      path: '/alternanzaTutor',
      name: 'alternanzaTutor',
      component: GestioneAlternanzaTutor
    },
    {
      path: '/gestioneAlternanza',
      name: 'gestioneAlternanza',
      component: GestioneAlternanzaAzienda
    },
    {
      path: '/colloquiIstituto',
      name: 'colloquiIstituto',
      component: GestioneProgettoCV
    },
    {
      path: '/colloquiAzienda',
      name: 'colloquiAzienda',
      props: true,
      component: ColloquiAzienda
    },
    {
      path: '/elencoColloqui',
      name: 'elencoColloqui',
      component: ElencoColloquiCV
    },
    {
      path: '/iscrizioneTirEstivi',
      name: 'iscrizioneTirEstivi',
      component: IscrizioniTirEstivi
    },
    {
      path: '/tirEstiviAzienda',
      name: 'tirEstiviAzienda',
      props: true,
      component: TirEstivi
    },
    // {
    //   path: '/tirociniEstiviAzienda',
    //   name: 'tirociniEstiviAzienda',
    //   props: true,
    //   component: TirociniEstiviAzienda
    // },
    {
      path: '/richiestaTirocinantiEstivi',
      name: 'richiestaTirocinantiEstivi',
      props: true,
      component: RichiestaTirocinantiEstivi
    },
    {
      path: '/gestioneTirEstivi',
      name: 'gestioneTirEstivi',
      component: GestioneTirEstiviAzienda
    },
    {
      path: '/tirEstiviTutor',
      name: 'tirEstiviTutor',
      component: GestioneTirEstiviTutor
    },
    {
      path: '/allieviAziendeTirEstivi',
      name: 'allieviAziendeTirEstivi',
      component: AssegnazioneAllieviAziendeTirEstivi
    },
    {
      path: '/tirociniEstiviIstituto',
      name: 'tirociniEstiviIstituto',
      component: GestioneTirEstivi
    },
    {
      path: '/gestioneTirEstiviTutorForm',
      name: 'gestioneTirEstiviTutorForm',
      component: GestioneTirEstiviTutorForm
    },
    {
      path: '/tirFormativiAzienda',
      name: 'tirFormativiAzienda',
      props: true,
      component: TirFormativi
    },
    {
      path: '/iscrizioneTirFormativi',
      name: 'iscrizioneTirFormativi',
      component: IscrizioniTirFormativi
    },
    {
      path: '/richiestaTirocinantiFormativi',
      name: 'richiestaTirocinantiFormativi',
      props: true,
      component: RichiestaTirocinantiFormativi
    },
    {
      path: '/allieviAziendeTirFormativi',
      name: 'allieviAziendeTirFormativi',
      props: true,
      component: AssegnazioneAllieviAziendeTirFormativi
    },
    {
      path: '/tirociniFormativiIstituto',
      name: 'tirociniFormativiIstituto',
      component: GestioneTirFormativi
    },
    {
      path: '/tirFormativiTutor',
      name: 'tirFormativiTutor',
      component: GestioneTirFormativiTutor
    },
    {
      path: '/gestioneTirFormativiTutorForm',
      name: 'gestioneTirFormativiTutorForm',
      component: GestioneTirFormativiTutorForm
    },
    {
      path: '/gestioneTirFormativi',
      name: 'gestioneTirFormativi',
      component: GestioneTirFormativiAzienda
    },
    {
      path: '/gestioneTirEstiviTutorAziendale',
      name: 'gestioneTirEstiviTutorAziendale',
      component: GestioneTirEstiviTutorAzienda
    },
    {
      path: '/reportVisiteIstituto',
      name: 'reportVisiteIstituto',
      component: GestioneReportVisite
    },
    {
      path: '/curriculumVitae',
      name: 'curriculumVitae',
      component: Curriculum
    },
    {
      path: '/curriculumVitae/:idIstituto',
      name: 'curriculumVitaeAnni',
      props: true,
      component: CurriculumAnno
    },
    {
      path: '/curriculumVitae/:idIstituto/:idAnnoScolastico',
      name: 'curriculumVitaeArticolazioni',
      props: true,
      component: CurriculumArticolazioni
    },
    {
      path: '/curriculumVitae/:idIstituto/:idAnnoScolastico/:idArticolazione',
      name: 'curriculumVitaeClassi',
      props: true,
      component: CurriculumClassi
    },
    {
      path: '/curriculumVitae/:idIstituto/:idAnnoScolastico/:idArticolazione/:classe',
      name: 'curriculumVitaeAllievi',
      props: true,
      component: CurriculumAllievi
    },
    {
      path: "/gestioneTirFormativiTutorAziendale",
      name: "gestioneTirFormativiTutorAziendale",
      component: GestioneTirFormativiTutorAzienda
    },
    {
      path: "/elencoAttivita",
      name: "elencoAttivita",
      component: ListaAttivita
    },
    {
      path: '/gestioneAlternanzaTutorAziendale',
      name: 'gestioneAlternanzaTutorAziendale',
      component: GestioneAlternanzaTutorAzienda
    },
    {
      path: '/gestioneAlternanzaTutorForm',
      name: 'gestioneAlternanzaTutorForm',
      component: GestioneAlternanzaTutorForm
    },
    {
      path: '/iscrizioniAllievoAttivitaIstituto',
      name: 'iscrizioniAllievoAttivitaIstituto',
      component: IscrizioniAttivitaAllievo
    },
    {
      path: '/iscrizioniWorkshop',
      name: 'iscrizioniWorkshop',
      component: IscrizioniWokshop
    },
    {
      path: '/allieviAziendeTirReIns',
      name: 'allieviAziendeTirReIns',
      component: AssegnazioneAllieviAziendeTirReIns
    },
    {
      path: '/gestioneTirReIns',
      name: 'gestioneTirReIns',
      component: GestioneTirReInsAzienda
    },
    {
      path: '/gestioneIscrizioniWorkshop',
      name: 'gestioneIscrizioniWorkshop',
      component: GestioneIscrizioniWorkshop
    },
    {
      path: "/questionariWokshop",
      name: "questionariWokshop",
      component: QuestionariWorkshop
    },
    {
      path: '/schedulazioneWorkshop',
      name: 'schedulazioneWorkshop',
      component: SchedulazioneWorkshop
    },
    {
      path: '/schedulazioneWorkshopTutor',
      name: 'schedulazioneWorkshopTutor',
      component: SchedulazioneWorkshopTutor
    },
    {
      path: "/elencoAllieviAssegnatiTutor",
      name: 'elencoAllieviAssegnatiTutor',
      component: ElencoAllieviAssegnatiTutor
    },
    {
      path: "/proposteLavoroIstituto",
      name: "proposteLavoroIstituto",
      component: ProposteLavoro
    },
    {
      path: '/apprendistati',
      name: 'apprendistati',
      component: Apprendistati
    },
    {
      path: '/allieviIscrittiAlternanza',
      name: 'allieviIscrittiAlternanza',
      component: ListaAllieviIscrittiAlternanza
    },
    {
      path: '/allieviIscrittiTirEstivi',
      name: 'allieviIscrittiTirEstivi',
      component: ListaAllieviIscrittiTirEstivi
    },
    {
      path: '/allieviIscrittiTirFormativi',
      name: 'allieviIscrittiTirFormativi',
      component: ListaAllieviIscrittiTirFormativo
    },
    {
      path: '/allieviIscrittiTirReIns',
      name: 'allieviIscrittiTirReIns',
      component: ListaAllieviIscrittiTirReIns
    },
    {
      path: '/assegnazioniAreeAllievi',
      name: 'assegnazioniAreeAllievi',
      component: AssegnazioneAreeAllievi
    },
    {
      path: '/assegnazioniAreeAziende',
      name: 'assegnazioniAreeAziende',
      component: AssegnazioneAreeAziende
    },
    {
      path: '/allieviSettoreAlternanza',
      name: 'allieviSettoreAlternanza',
      component: AllieviSettoreAlternanza
    },
    {
      path: '/crypt',
      name: 'crypt',
      component: Crypt
    },
    {
      path: '/statistiche',
      name: 'statistiche',
      component: Statistiche
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/signUp', '../../assets/Informativa_Privacy.pdf', '/signUpSuccess', '/validationPage', '/sessionExpired', '/resetPasswordPage', '/crypt', '/pdfPreview'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('userToken');

  if (authRequired && !loggedIn) {
    return next('/login');
  } else {
    next();
  }


});